import { useState, useContext } from 'react'
import { Lock, User, Eye, EyeOff, TrendingUp, ShoppingBag, MapPin, Share2, BarChart2, Globe } from 'lucide-react'
import { AuthContext } from '../context/AuthContext'
import './LoginPage.css'

export default function LoginPage() {
  const [email, setEmail]               = useState('')
  const [password, setPassword]         = useState('')
  const [showPassword, setShowPassword] = useState(false)
  const [error, setError]               = useState('')
  const [loading, setLoading]           = useState(false)

  const { login } = useContext(AuthContext)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError('')
    setLoading(true)
    const result = await login(email, password)
    if (!result.success) setError(result.error || 'Credenciales incorrectas')
    setLoading(false)
  }

  return (
    <div className="login-root">

      {/* ── LADO IZQUIERDO — Hero ── */}
      <div className="login-hero">
        <div className="hero-overlay" />
        <div className="hero-content">
          <div className="hero-brand">
            <div className="hero-logo">
              <BarChart2 size={28} strokeWidth={1.5} />
            </div>
            <span className="hero-brand-name">Global Market</span>
          </div>

          <div className="hero-text">
            <h1>Market Research<br /><span>Intelligence</span></h1>
            <p>Analiza tendencias, productos y competidores en los mercados Tier1 en tiempo real.</p>
          </div>

          <div className="hero-apis">
            <div className="api-badge"><TrendingUp size={14} /> Google Trends</div>
            <div className="api-badge"><ShoppingBag size={14} /> Amazon</div>
            <div className="api-badge"><MapPin size={14} /> Google Maps</div>
            <div className="api-badge"><Share2 size={14} /> Pinterest</div>
            <div className="api-badge"><Globe size={14} /> Facebook Ads</div>
          </div>

          <div className="hero-stats">
            <div className="stat"><span className="stat-num">6</span><span className="stat-lbl">APIs</span></div>
            <div className="stat-divider" />
            <div className="stat"><span className="stat-num">Tier1</span><span className="stat-lbl">Mercados</span></div>
            <div className="stat-divider" />
            <div className="stat"><span className="stat-num">Real</span><span className="stat-lbl">Time</span></div>
          </div>
        </div>
      </div>

      {/* ── LADO DERECHO — Formulario ── */}
      <div className="login-panel">
        <div className="login-form-wrap">

          <div className="login-badge">Acceso Protegido</div>
          <h2 className="login-title">Iniciar Sesión</h2>
          <p className="login-subtitle">Panel exclusivo de administración</p>

          <form onSubmit={handleSubmit} className="login-form">
            <div className="field-group">
              <label>Usuario</label>
              <div className="field-wrap">
                <User className="field-icon" size={17} />
                <input
                  type="text"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  placeholder="Introduce tu usuario"
                  required
                  disabled={loading}
                  autoComplete="username"
                />
              </div>
            </div>

            <div className="field-group">
              <label>Contraseña</label>
              <div className="field-wrap">
                <Lock className="field-icon" size={17} />
                <input
                  type={showPassword ? 'text' : 'password'}
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  placeholder="Introduce tu contraseña"
                  required
                  disabled={loading}
                  autoComplete="current-password"
                />
                <button
                  type="button"
                  className="toggle-pass"
                  onClick={() => setShowPassword(!showPassword)}
                  tabIndex={-1}
                >
                  {showPassword ? <EyeOff size={17} /> : <Eye size={17} />}
                </button>
              </div>
            </div>

            {error && <div className="login-error">{error}</div>}

            <button type="submit" className="btn-login" disabled={loading}>
              {loading ? 'Verificando...' : 'Ingresar al Panel →'}
            </button>
          </form>

          <p className="login-note">Solo para administradores autorizados</p>
        </div>
      </div>

    </div>
  )
}
